<template>
  <div class="p-register-nav">
    <Button variant="light" class="logout" radius @click="logout">
      ログアウト
    </Button>
  </div>
</template>

<script>
import Button from '@/components/Button';

export default {
  components: {
    Button
  },
  methods: {
    logout() {
      this.auth.logout();
    }
  }
};
</script>
